export default "__VITE_ASSET__srB5LE7w__"